<!-- https://eugenkiss.github.io/7guis/tasks#timer -->

<script>
	import { onDestroy } from 'svelte';
	
	let Time = {
		Fraction: {
			MS: 1,
			S: 1000,
			M: 60,
			HR: 60,
			D: 24,
		},
		Units: {
			MS: "miliseconds",
			S: "seconds",
			M: "minutes",
			HR: "hours",
			D: "days",
		},
		Convert: {},
	};
	
	Time.Convert = {
		toMS: (value, unit) => {
			if (unit == null || unit == "MS") {
				return value;
			} else {
				let units = Object.keys(Time.Fraction);
				return Time.Convert.toMS(value * Time.Fraction[unit], units[units.indexOf(unit)-1]);
			}
		},
		fromMS: (value, unit, current_unit = 0) => {
			let units = Object.keys(Time.Fraction);
			units = units.slice(0, units.indexOf(unit)+1);
			let them = units.map(u => Time.Fraction[u]);
			return them.reduce((a,c) => a / c, value);
		}
	};

	let title = "timer";
	let elapsed = 0;
	let duration = 5000;
	let input_duration = 5;
	let units = "S";

	let last_time = window.performance.now();
	let frame;
	
	let paused = true;

	const reset = () => {
		elapsed = 0;
	};

	const startStop = () => {
		if (paused) {
			last_time = window.performance.now();
			frame = requestAnimationFrame(update);
		} else {
			cancelAnimationFrame(frame);
		}
		paused = !paused;
	};
	
	function update() {
		frame = requestAnimationFrame(update);

		const time = window.performance.now();
		elapsed += Math.min(
			time - last_time,
			duration - elapsed
		);

		last_time = time;
	};
	
	const notify = () => new Notification(title, { 
		body: `Your timer for ${Time.Convert.fromMS(duration, units)} ${Time.Units[units]} is up!`, 
		icon: "https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/120/google/263/alarm-clock_23f0.png"
	});
	
	$: if (elapsed == duration) {
		startStop();
		reset();
		if (Notification.permission !== 'denied' || Notification.permission !== 'default') {
			notify();
		} else {
			Notification.requestPermission().then(function(result) {
				if (result == "granted") {
					notify();
				}
			});
		}
	}

	onDestroy(() => {
		cancelAnimationFrame(frame);
	});
	
	const handleUnitChange = (event) => {
		let unit_string = event.target.value;
		duration = Time.Convert.toMS(input_duration, unit_string);
	};
	
	const handleInputChange = (event) => {
		duration = Time.Convert.toMS(event.target.value, units);
	};
</script>

<h1 style="grid-area: header;">Timer</h1>

<fieldset style="grid-area: details;">
	<legend>Details</legend>
	<div><b>Duration</b>: {Time.Convert.fromMS(duration, units)}{units.toLowerCase()}</div>
	<div><b>Elapsed</b>: {Time.Convert.fromMS(elapsed, units).toFixed(2)}{units.toLowerCase()}</div>
	<b>Progress</b>: <br/><progress value="{elapsed / duration}"></progress>
</fieldset>
<fieldset style="grid-area: title;">
	<legend>Title</legend>
	<input type="text" bind:value="{title}" placeholder="the name your reminder will show"/>
</fieldset>
<fieldset style="grid-area: time;">
	<legend>
		Duration
	</legend>
	<input type="number" bind:value={input_duration} on:change="{handleInputChange}" />
	<!-- svelte-ignore a11y-no-onchange -->
	<select on:change={handleUnitChange} bind:value="{units}">
		<option value="MS">miliseconds</option>
		<option value="S" selected>seconds</option>
		<option value="M">minutes</option>
		<option value="HR">hours</option>
	</select>
</fieldset>

<fieldset style="grid-area: controls;">
	<legend>
		Controls
	</legend>
	
	<input type=button value={paused ? "start" : "stop"} on:click={startStop}/>
	<input type=button value="reset" on:click={reset} disabled={!paused}/>
</fieldset>

<style>

</style>